let lenis = null;

export const setLenis = (instance) => { lenis = instance; };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const WHATSAPP_NUMBER = "919148236699";
export const WHATSAPP_DISPLAY = "+91 91482 36699";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Amara Studios! I'd like to enquire about getting a website for my business."
)}`;
